import PageTitle from "../../components/custom/components/PageTitle";
import AdminLayout from "../../components/custom/layouts/AdminLayout";

const HolidaySetting = () => {
    return <AdminLayout>
        <PageTitle
            title='Holiday Setting'
        />
        {/* <div className="card">
       <div className="card-body">
           
       </div>
   </div> */}
    </AdminLayout>
}
export default HolidaySetting;      
